<template>    
    <page-layout>
        <has-app 
            :app="$route.params.app"
            :universe="$route.params.universe"
        >
            <infinity-page
                icon="$vuetify.icons.app"
                color="teal"
                :loading="loading"
            >
                <app-drawer />
                <template #title>
                    <v-toolbar 
                        flat
                        prominent
                        class="pa-0"
                    >
                        <div>
                            <h1
                                style="font-weight: 300; font-family: lato; font-weight: bold; letter-spacing: initial;"
                            >
                                {{ app.name }}
                            </h1>
                            <h2 
                                style="font-weight: 200"
                                v-html="app.subtitle || '&nbsp;'"
                            />
                        </div>
                        <v-spacer />
                        <build-o 
                            :universe="app.universe"
                            :app="app.name"
                            info
                            class="mt-4"
                        />
                        <app-state
                            :universe="app.universe"
                            :app="app.name"
                            info
                            class="mt-4"
                        />
                    </v-toolbar>
                </template>
                <template #actions>                    
                    <v-spacer />                    
                </template>                
                <v-sheet>        
                    <v-container>                        
                        <job />
                    </v-container>                    
                </v-sheet>
                <template #sidebar>
                    <infinity-sidebar
                        icon="$vuetify.icons.help"
                        title="docs/multiverse"
                    >
                        <h4 class="text-h4 mb-3 text--primary">
                        Settings for the platform
                        </h4>

                        <p class="text--secondary">
                            Settings for the platform can be set on this page
                        </p>

                        <v-btn
                            class="mr-0 white--text"
                            color="deep-purple"                            
                            min-width="100"
                            rounded
                        >
                            I want to know more
                        </v-btn>
                        <v-timeline
                            v-if="builds.length"
                            dense
                            align-top
                        >
                            <v-timeline-item
                                v-for="build in builds"
                                :key="build.ID"
                                :color="color(build)"
                                :icon="icon(build)"
                                align-top
                                :icon-color="iconColor(build)"
                            >
                                <v-card
                                    :color="color(build)"
                                    dark
                                    hover                                    
                                    :elevation="selected(build) ? 8 : ''"
                                    :to="`/ui/universe/${$route.params.universe}/apps/app/${$route.params.app}/logbook/${build.ID}/`"
                                >
                                    <v-card-title 
                                        :class="`text-h6 ${textColor(build)}`"
                                    >
                                        {{ new Date(build.Created).toLocaleString() }}
                                    </v-card-title>
                                </v-card>
                            </v-timeline-item>
                        </v-timeline>
                    </infinity-sidebar>
                </template>
            </infinity-page>
        </has-app>
    </page-layout>
</template>
<script>
    // import VJsf from '@koumoul/vjsf/lib/VJsf.js'
    import axios from 'axios'
    import PageLayout from '@/layouts/default/PageLayout'    
    import AppDrawer from '@/layouts/App/Drawer'    
    import BuildO from '../../layouts/App/widgets/BuildO'
    import AppState from '../../layouts/App/widgets/State'
    import Job from '../../layouts/App/widgets/Job'
    import { mapState, mapActions } from 'pinia'
    import { useAppStore } from '@/store/app-store'
    import schema from '@/assets/schemas/app/setting.json'

    export default {
        components: {
            // VJsf,
            PageLayout,
            AppDrawer,
            BuildO,
            AppState,
            Job,
        },
        data: () => {
            return {
                model: {},
                schema: schema,
                options: {
                    httpLib: axios,
                    fieldProps: {
                        outlined: true,
                    },
                    arrayItemColProps: { cols: 12 },
                    arrayItemCardProps: {
                        outlined: true,
                        hover: true,
                        shaped: true,
                        style: 'margin: 10px',
                    },
                },
            }
        },
        computed: {
            ...mapState(useAppStore, ['app', 'builds', 'loading']),            
        },
        async mounted () {
            await this.loadBuilds(this.$route.params.universe, this.$route.params.app)
            this.model = await this.loadApp(this.$route.params.universe, this.$route.params.app)            
        },        
        methods: {
            ...mapActions(useAppStore, ['loadApp', 'loadBuilds']),
            color (buildItem) {
                if (buildItem.ID === this.$route.params.jobId) {
                    return 'deep-purple'
                }
                switch (buildItem.State) { 
                    case 'Failed': return 'red lighten-2'
                    case 'Canceled': return 'grey lighten-4'
                }
                return 'green lighten-2'
            },
            icon (buildItem) {                
                switch (buildItem.State) { 
                    case 'Failed': return 'mdi-robot-dead'
                    case 'Canceled': return 'mdi-robot-off'
                }
                return 'mdi-robot-love'
            },
            iconColor (buildItem) {
                if (buildItem.ID === this.$route.params.jobId) {
                    return 'white'
                }
                switch (buildItem.State) { 
                    case 'Failed': return 'white'
                    case 'Canceled': return 'grey darken-3'
                }
                return 'white'
            },
            textColor (buildItem) {
                if (buildItem.ID === this.$route.params.jobId) {
                    return 'white--text'
                }
                switch (buildItem.State) { 
                    case 'Failed': return 'white--text'
                    case 'Canceled': return 'grey--text text--darken-3'
                }
                return 'white--text'
            },
            selected (buildItem) {
                return buildItem.ID === this.$route.params.jobId
            },
        },
    }
</script>
<style scoped>
.vjsf >>> .v-card__title {
    font-size: 24px ! important;
    font-weight: 600;
    font-family: 'lato' ! important;
}
</style>
